import { render, staticRenderFns } from "./biaochi.vue?vue&type=template&id=5835f76a&"
import script from "./biaochi.vue?vue&type=script&lang=ts&"
export * from "./biaochi.vue?vue&type=script&lang=ts&"
import style0 from "./biaochi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports